import React from 'react';
import Popup from "reactjs-popup";

class DefaultPopup extends Popup {

    componentDidMount() {

        let popupStyle = {
            background: "transparent none",
            border: "none",
            borderRadius: "4px",
            padding: "0"
        };

        if (typeof this.props.popupStyle != 'undefined') {
            Object.assign(popupStyle, this.props.popupStyle);
        }

        this.setState({
            popupStyle
        });
    }

    render() {
        const { onClosePopup, onOpenPopup, openPopup, title, trigger } = this.props;
        const children = 'function' === typeof this.props.children ? '' : this.props.children;

        let contentClass = '';

        if (typeof this.props.contentClassName != 'undefined') {
            contentClass += ' ' + this.props.contentClassName;
        }

        return (
            <Popup closeOnDocumentClick
                contentStyle={this.state.popupStyle}
                modal
                onClose={() => 'function' === typeof onClosePopup ? onClosePopup() : null}
                onOpen={() => 'function' === typeof onOpenPopup ? onOpenPopup() : null}
                open={openPopup}
                position="top left"
                trigger={trigger}>
                {close => (
                    <div className="wrapper">
                        <header className="header py-2">
                            <a className="close" onClick={close}>&times;</a>
                            {title}
                        </header>
                        <div className={contentClass}>
                            {children}
                        </div>
                    </div>
                )}
            </Popup>
        );
    }
}

export default DefaultPopup;